import * as React from 'react';
import Typography from '../../../commonComponents/Typography/Typography';
import Box from '../../Box';
import Popover from '../../../Popover';

interface TooltipProps {
  title: string;
  disabled?: boolean;
  children?: React.ReactNode;
}

const Tooltip: React.FC<TooltipProps> = ({ title, disabled, children }) => {
  return (
    <Popover
      id={`tooltip-${title}`}
      disabled={disabled}
      content={
        <Box p={2}>
          <Typography kind="label">{title}</Typography>
        </Box>
      }
      placement="right"
      trigger="hover"
      width="auto"
    >
      {typeof children === 'string' ? <span>{children}</span> : children}
    </Popover>
  );
};

export default Tooltip;
